module.exports = __webpack_public_path__ + "static/media/Troy.8aa6b9c4.jpg";